import { Zap } from "lucide-react";
import { cn } from "@/lib/utils";

export function XpBadge({ xp, className }: { xp: number; className?: string }) {
  return (
    <div
      className={cn(
        "flex items-center gap-1.5 rounded-full bg-primary/10 px-3 py-1.5 text-sm font-bold text-primary",
        className,
      )}
      aria-label={`${xp} experience points`}
    >
      <Zap className="h-4 w-4 fill-current" />
      <span className="tabular-nums">{xp}</span>
      <span className="hidden sm:inline text-xs font-semibold opacity-70">XP</span>
    </div>
  );
}
